/* eslint-disable @typescript-eslint/no-unused-vars */
import { Col, Row, Select, Form, Tabs, Tooltip } from 'antd';
import React, { Dispatch, useEffect, useState } from 'react';

import { Container, ModalEnd, ModalTransp, SelectControl, TilteEndTransp } from './styles';
import { CriaEndereco, EnderecoService } from '../../../services/estoqueServices';
import { useDispatch, useSelector } from 'react-redux';
import { ApplicationState } from '../../../../../store';
import mask from '../../../../../utils/mask';
import { Action } from 'typesafe-actions';
import { addItemRequest } from '../../../../../store/ducks/estoqueCart/actions';
import { EndProps } from './props';
import axios from 'axios';
import Swal from 'sweetalert2';
import { useForm } from 'antd/lib/form/Form';
import { loadRequestCid } from '../../../../../store/ducks/estadoCidade/actions';

const ModalEndereco: React.FC<EndProps> = ({ codProduto, controle, endereco, codParceiro }) => {
  const inscricaoAtiva = useSelector((state: ApplicationState) => state.auth.inscricaoAtiva);
  const estoqueCart = useSelector((state: ApplicationState) => state.EstoqueCart.cart);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [radio, setRadio] = useState<any>(1);
  const [response, setResponse] = useState<any>([]);
  const [resp, setResp] = useState<any>({});
  const [cep, setCep] = useState<any>();

  const [logradouro, setLogradouro] = useState<any>();
  const [cidade, setCidade] = useState<any>();
  const [estado, setEstado] = useState<any>();
  const [numero, setNumero] = useState<any>();
  // eslint-disable-next-line
  const [loading, setLoading] = useState(false);
  const [control, setControl] = useState(false);
  const [controller, setControlller] = useState(false);
  // eslint-disable-next-line
  const [index, setIndex] = useState<any>();
  const [form] = useForm();
  const { TabPane } = Tabs;
  const dispatch = useDispatch<Dispatch<Action>>();
  const { Option } = Select;
  useEffect(() => {
    try {
      EnderecoService.getEnderecos(inscricaoAtiva).then((res) => {
        setResponse(res?.data.enderecos);
      });
    } finally {
    }
  }, [inscricaoAtiva]);

  // eslint-disable-next-line
  const enderecoSelecionado = response?.map((endSelect: any) => {
    if (response?.map((enD: any) => enD.isPadrao === true && endSelect.isPadrao === true)) {
      return {
        codEndereco:
          response?.find(
            (eN: any) =>
              eN.isPadrao === endSelect.isPadrao && eN.codParceiro === endSelect.codParceiro
          ) && endSelect?.codEndereco,
        codParceiro:
          response?.find(
            (eN: any) =>
              eN.isPadrao === endSelect.isPadrao && eN.codParceiro === endSelect.codParceiro
          ) && endSelect?.codParceiro,
        nomeEndereco:
          response?.find((nameEnd: any) => nameEnd.isPadrao === endSelect.isPadrao) &&
          mask('camelCase', endSelect?.nomeEndereco) +
            endSelect?.numEndereco +
            ', ' +
            mask('camelCase', `${endSelect?.bairro},`) +
            mask('camelCase', `${endSelect?.cidade}-`) +
            endSelect?.uf,
      };
    }
    if (response?.map((enDe: any) => enDe.isPadrao === false && endSelect.isPadrao === false)) {
      return {
        codEndereco:
          response?.find((codEnd: any) => codEnd.codParceiro === endSelect.codParceiro) &&
          endSelect?.codEndereco,
        nomeEndereco:
          response?.find((coDEnd: any) => coDEnd.codParceiro === endSelect.codParceiro) &&
          mask('camelCase', endSelect?.nomeEndereco) +
            endSelect?.numEndereco +
            ', ' +
            mask('camelCase', `${endSelect?.bairro},`) +
            mask('camelCase', `${endSelect?.cidade}-`) +
            endSelect?.uf,
      };
    }
  });

  const enderecoPadrao = enderecoSelecionado.find(
    (ePadrao: any) => ePadrao.codParceiro === codParceiro && ePadrao
  );

  useEffect(() => {
    const indexcard = estoqueCart?.findIndex(
      (c, indexa) => c.codProduto === codProduto && c.controle === controle
    );
    if (indexcard !== -1 && indexcard !== undefined) {
      const newEstoque = estoqueCart;
      newEstoque[indexcard] = {
        ...newEstoque[indexcard],
        endereco: enderecoPadrao?.nomeEndereco,
      };

      dispatch(addItemRequest(newEstoque));
    }
    setControlller(true);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [enderecoPadrao?.nomeEndereco]);

  const showModal = () => {
    setIsModalVisible(true);
    setControl(false);
    setRadio(1);
    limpa_formulário_cep();
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    limpa_formulário_cep();
  };

  const handleOk = (values: any) => {
    setIsModalVisible(false);

    const enderecoFull = {
      cep: cep,
      numEndereco: values.numero,
      nomeEndereco: values.rua,
      bairro: values.bairro,
      cidade: values.cidade,
      uf: values.uf,
      complemento: values.complemento === undefined ? '' : values.complemento,
    };
    if (radio === 1) {
      const indexcard = estoqueCart?.findIndex(
        (c, indexa) => c.codProduto === codProduto && c.controle === controle
      );
      if (indexcard !== -1 && indexcard !== undefined) {
        const newEstoque = estoqueCart;
        newEstoque[indexcard] = {
          ...newEstoque[indexcard],
          endereco: values.endCad === undefined ? enderecoPadrao.nomeEndereco : values.endCad,
        };

        dispatch(addItemRequest(newEstoque));
      } else {
        dispatch(addItemRequest([...estoqueCart, resp]));
      }
    } else if (radio === 2 && control === false) {
      setLoading(true);
      setControl(true);
      try {
        CriaEndereco.criaEnderecoParceiro(codParceiro, enderecoFull).then((res) => {
          setLoading(true);
          Swal.fire({
            title: 'Endereço criado com sucesso!',
            html: '',
            icon: 'success',
            showConfirmButton: false,
            timer: 1500,
          }).then((resul) => {
            setLoading(false);
            try {
              EnderecoService.getEnderecos(inscricaoAtiva).then((res) => {
                setResponse(res?.data.enderecos);
              });
            } finally {
            }
            if (resul) {
              const indexcard = estoqueCart?.findIndex(
                (c, indexa) => c.codProduto === codProduto && c.controle === controle
              );

              if (indexcard !== -1 && indexcard !== undefined) {
                const newEstoque = estoqueCart;
                newEstoque[indexcard] = {
                  ...newEstoque[indexcard],
                  endereco:
                    mask('camelCase', res.data.endereco.nomeEndereco) +
                    res.data.endereco.numEndereco +
                    ', ' +
                    mask('camelCase', `${res.data.endereco.bairro},`) +
                    mask('camelCase', `${res.data.endereco.cidade}-`) +
                    res.data.endereco.uf,
                };
                dispatch(addItemRequest(newEstoque));
              } else {
                limpa_formulário_cep();
                Swal.fire({
                  title: 'Erro:',
                  html:
                    'Não é possível cadastrar o endereço, por favor cadastre outro endereço ou verifique a lista de endereços cadastrados!',
                  icon: 'warning',
                });
                dispatch(addItemRequest([...estoqueCart, resp]));
              }
            }
          });
        });
      } finally {
        setLoading(false);
        limpa_formulário_cep();
      }
    }
  };

  const handleSelectDataChange = (value: any, end: any) => {
    setIndex(codProduto);
    setResp(end?.children);
  };

  const limpa_formulário_cep = () => {
    setCep('');
    setCidade('');
    setEstado('');
    setNumero('');
    form.setFieldsValue({
      cep: '',
      rua: '',
      cidade: '',
      bairro: '',
      estado: '',
      uf: '',
      numero: '',
      complemento: '',
    });
  };

  const pesquisacep = (valor: any) => {
    var cepP = valor?.replace(/\D/g, '');
    setCep(cepP);

    if (cepP !== '') {
      var validacep = /^[0-9]{8}$/;

      if (validacep.test(cepP)) {
        try {
          axios.get(`https://viacep.com.br/ws/${cepP}/json/`).then((responseEnd) => {
            form.setFieldsValue({
              rua: responseEnd.data.logradouro,
              cidade: responseEnd.data.localidade,
              bairro: responseEnd.data.bairro,
              uf: responseEnd.data.uf,
            });
            if (responseEnd.data.erro) {
              Swal.fire({
                title: `CEP não encontrado, por favor insira os dados do endereço manualmente!`,
                html: '',
                icon: 'warning',
              });
            } else if (
              !responseEnd.data.logradouro ||
              !responseEnd.data.bairro ||
              !responseEnd.data.localidade ||
              !responseEnd.data.uf
            ) {
              Swal.fire({
                title: `Desculpe não encontramos todos os dados referente ao seu CEP, por favor preencha manualmente os dados faltantes!`,
                html: '',
                icon: 'warning',
              });
            }
          });
        } catch (error) {
          Swal.fire({
            title: `Consulta do CEP falhou, por favor tente novamente!`,
            html: '',
            icon: 'warning',
            showConfirmButton: false,
            timer: 1500,
          });
        }
      } else {
        limpa_formulário_cep();
        Swal.fire({
          title: `Formato de CEP inválido ou não existe!`,
          html: '',
          icon: 'warning',
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } else {
      limpa_formulário_cep();
    }
  };

  const onChangeEst = (value: any, key: any) => {
    setEstado(key?.key);
    dispatch(loadRequestCid(key?.key));
    form.setFieldsValue({
      cidade: '',
    });
  };

  const onChange = (e: any) => {
    setRadio(+e);
  };

  const modalSelectEnd = (
    <Row gutter={24}>
      <Col md={24} sm={24} xs={24}>
        <Form form={form} id="key" name="basic" onFinish={(values) => handleOk(values)}>
          <Tabs onChange={onChange} defaultActiveKey="1">
            <TabPane tab="Endereço cadastrado" key="1">
              <ModalTransp>
                <Form.Item name="endCad">
                  <SelectControl
                    showSearch
                    getPopupContainer={(triggerNode: HTMLElement) =>
                      triggerNode.parentNode as HTMLElement
                    }
                    id="endCad"
                    onChange={handleSelectDataChange}
                    placeholder={'Selecione endereço cadastrado'}
                    filterOption={(inputValue, element) =>
                      element?.props.children
                        .toString()
                        .toLowerCase()
                        .includes(inputValue.toLowerCase())
                    }
                    value={
                      mask('camelCase', response?.nomeEndereco) +
                      response?.numEndereco +
                      ', ' +
                      mask('camelCase', `${response?.bairro},`) +
                      mask('camelCase', `${response?.cidade}-`) +
                      response?.uf
                    }
                    defaultValue={enderecoPadrao?.nomeEndereco}
                  >
                    {response?.map((end: any) => (
                      <Option
                        value={
                          mask('camelCase', end?.nomeEndereco) +
                          end?.numEndereco +
                          ', ' +
                          mask('camelCase', `${end?.bairro},`) +
                          mask('camelCase', `${end?.cidade}-`) +
                          end?.uf
                        }
                        key={end.codEndereco}
                      >
                        {mask('camelCase', end?.nomeEndereco) +
                          end?.numEndereco +
                          ', ' +
                          mask('camelCase', `${end?.bairro},`) +
                          mask('camelCase', `${end?.cidade}-`) +
                          end?.uf}
                      </Option>
                    ))}
                  </SelectControl>
                </Form.Item>
              </ModalTransp>
            </TabPane>
          </Tabs>
        </Form>
      </Col>
    </Row>
  );

  return (
    <>
      <Container>
        <TilteEndTransp>Endereço: </TilteEndTransp>
        <ModalEnd>
          <Tooltip title={enderecoPadrao?.nomeEndereco}>{enderecoPadrao?.nomeEndereco}</Tooltip>
        </ModalEnd>
      </Container>
    </>
  );
};

export default ModalEndereco;
